/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Block_Age_UnknownInputs */



/**
* | output |
* | --- |
* | "start date not recorded" |
*
* @param {Partner_Billing_Board_Block_Age_UnknownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_block_age_unknown = /** @type {((inputs?: Partner_Billing_Board_Block_Age_UnknownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Block_Age_UnknownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Startdatum nicht erfasst")
	return /** @type {LocalizedString} */ ("start date not recorded")
});